// extracted by mini-css-extract-plugin
export var dropdownIcon = "_r1-6";
export var imgContainer = "_r1-3";
export var menuIcon = "_r1-5";
export var pillWrapper = "_r1-2";
export var pillsContainer = "_r1-1";
export var subscriptionCard = "_r1-0";
export var subscriptionLogo = "_r1-4";